import { FC } from 'react';
import { Divider, Form, Table, Typography } from 'antd';
import { useForm } from '@/libs/antd/form';
import ANTD_DEFAULT_PROPS from '@/libs/antd/props';
import { OfficeObservationSalesMethod } from '@/libs/fleet-api/services/types';
import { useFBDHVisitReportApprovalPage } from './VisitReportApproval';

type OfficeObservationSalesMethodData =
	OfficeObservationSalesMethod<'payload'> &
		Pick<OfficeObservationSalesMethod, 'salesMethod'>;

type VisitReportSalesMethodForm = {
	lists: OfficeObservationSalesMethodData[];
};

const FBDHisitReportSalesMethod: FC = () => {
	const { officeObservation } = useFBDHVisitReportApprovalPage();
	const { marketingAspect } = officeObservation ?? {};
	const { form, fieldName } = useForm<VisitReportSalesMethodForm>();

	return (
		<Form.Provider>
			<Typography.Title level={3}>Metode Penjualan</Typography.Title>
			<Form
				{...ANTD_DEFAULT_PROPS.FORM}
				form={form}
				initialValues={
					{
						lists:
							marketingAspect?.salesMethods?.map((record) => {
								return {
									methodDetail: record.methodDetail,
									salesMethod: record.salesMethod,
									salesMethodId: record.salesMethod.id,
									surveyId: record.surveyId,
									id: record.id,
								};
							}) ?? [],
					} as VisitReportSalesMethodForm
				}
				style={{ marginBottom: 30 }}
			>
				<Form.Item
					name={fieldName(['lists'])}
					noStyle
				/>
				<Form.Item shouldUpdate>
					{({ getFieldsValue }) => {
						const values = getFieldsValue() as VisitReportSalesMethodForm;
						const dataSource =
							values?.lists?.map((list, key?) => {
								return { ...list, key };
							}) ?? [];

						return (
							<Table
								bordered
								pagination={false}
								dataSource={dataSource}
								columns={[
									{
										title: 'No',
										width: 1,
										align: 'center',
										render: (_, __, index) => index + 1,
									},
									{
										title: 'Metode Penjualan',
										render: (_, record) => record.salesMethod.value ?? '-',
									},
									{
										title: 'Detail Metode Penjualan',
										render: (_, record) => record.methodDetail ?? '-',
									},
								]}
							/>
						);
					}}
				</Form.Item>
			</Form>
			<Divider />
		</Form.Provider>
	);
};

export default FBDHisitReportSalesMethod;
